export const SUPPORT_EMAIL = 'success@thanx.com'
